

export const homeObjOne = {
    id: 'discover',
    lightBg: false,
    lightText:true,
    lightTextDesc: true,
    topLine: 'Roofing',
    headline: 'Do you want to do a job on your roof?',
    description: 'We can offer you a variety of services for your roof such as: repair, cleaning, installation and maintenance to keep your roof in perfect condition.',
    buttonLabel: 'Get started',
    imgStart: false,
    img: require('../../images/house.svg').default,
    alt: 'Roofing',
    dark:true,
    primary:true,
    darkText: false

};

export const homeObjTwo = {
    id: 'discover',
    lightBg: true,
    lightText:false,
    lightTextDesc: false,
    topLine: 'Tile',
    headline: 'Do you want to change a floor and put ceramic tiles on it?',
    description: 'We offer you a personalized tile floor repair service, remove and install tile floors.',
    buttonLabel: 'Get started',
    imgStart: true,
    img: require('../../images/tile.svg').default,
    alt: 'Tile',
    dark:false,
    primary:false,
    darkText: true

};

export const homeObjThree = {
    id: 'experiences',
    lightBg: false,
    lightText:true,
    lightTextDesc: true,
    topLine: 'Experiences',
    headline: 'Do you want some kind of repair or personalized service?',
    description: 'We offer solutions according to the situation presented. We provide confidence and security in each work carried out. We can quote your repair or service immediately.',
    buttonLabel: 'Get started',
    imgStart: false,
    img: require('../../images/request.svg').default,
    alt: 'Innovation',
    dark:true,
    primary:true,
    darkText: false

};

export const homeObjServices = {
    //id: 'services',
    lightBg: false,
    lightText:true,
    lightTextDesc: true,
    buttonLabel: 'More',
    imgStart: false,
    //img: require('../../images/house.svg').default,
    //alt: 'Innovation',
    dark:false,
    primary:false,
    darkText: true

};

export const homeObjAbout = {
    id: 'about',
    lightBg: false,
    lightText:true,
    lightTextDesc: true,
    topLine: 'About Us',
    topLine2: 'MISSION',
   
    description: 'We can offer you a variety of services for your roof such as: repair, cleaning, installation and maintenance to keep your roof in perfect condition.',
    description2: 'Provide nationwide quality service, quality workmanship, correct facilities following the indicated protocols and adequate customer service to each of our clients.',
    buttonLabel: 'Contact us',
    buttonLabel1: 'Get started',
    imgStart: true,
    img: require('../../images/roof.png').default,
    alt: 'Roofing',
    dark:true,
    primary:true,
    darkText: false

};
